import { MINI_TRIAL_GUIDE_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { useEffect, useState } from 'react';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { useExperiments } from '../../../hooks/useNavConfig';
import { getExperimentGroup } from '../../../laboratory';
import { getCachedActiveTrials } from '../api/getCachedActiveTrials';
import { getActiveTrial, getMiniTrialGuideOpenFromStorage, setMiniTrialGuideState } from '../utils/localStorage';
import { findEarliestTrial, getDaysInTrialRemaining } from '../utils/trialUtils';
export const selectTrial = trials => {
  if (trials.length === 1) {
    return trials[0];
  }
  const activeTrial = getActiveTrial();
  return trials.find(trial => trial.trial.productApiNames.includes(activeTrial)) || findEarliestTrial(trials);
};
export const useMiniTrialGuide = () => {
  const {
    toggle: delayedToggle
  } = useToggleComponent(MINI_TRIAL_GUIDE_COMPONENT, {
    useScheduler: true
  });
  const experiments = useExperiments();
  const experimentGroup = getExperimentGroup('hc-0134', experiments);
  const [daysLeft, setDaysLeft] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const shouldRenderMiniTrialGuide = experimentGroup === 'variation' && daysLeft !== null;
  useEffect(() => {
    const fetchTrials = async () => {
      try {
        const activeHubTrials = await getCachedActiveTrials();
        if (activeHubTrials.length === 0) {
          setDaysLeft(null);
          return;
        }
        const selectedTrial = selectTrial(activeHubTrials);
        if (selectedTrial) {
          setDaysLeft(getDaysInTrialRemaining(selectedTrial.endsAt));
        }
      } catch (error) {
        setDaysLeft(null);
      } finally {
        setIsLoading(false);
      }
    };
    if (experimentGroup === 'variation') {
      void fetchTrials();
    }
  }, [experimentGroup]);
  useEffect(() => {
    if (isLoading) {
      return;
    }
    try {
      const isOpen = getMiniTrialGuideOpenFromStorage();
      if (shouldRenderMiniTrialGuide && isOpen) {
        delayedToggle(true);
      } else {
        setMiniTrialGuideState(false);
      }
    } catch (error) {
      setMiniTrialGuideState(false);
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error(new Error('Error rendering mini trial guide', {
        cause: error
      }));
    }
  }, [shouldRenderMiniTrialGuide, delayedToggle, isLoading]);
  return {
    shouldRenderMiniTrialGuide,
    daysLeft
  };
};